import checkrApiClient from '../checkrApiClient';
import { CHECKR_BFF_API_BASE } from '../../constants';
import { PromptGroup } from '../../types/candidateStories';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
};

const baseUrl = `${CHECKR_BFF_API_BASE}`;

export const getCandidateStoryPrompts = async (): Promise<{
  data: PromptGroup[];
}> => {
  const response = await checkrApiClient.get<{ data: PromptGroup[] }>(
    `${baseUrl}/candidate_stories/prompt_groups`,
    {
      params: { token: window.sessionStorage.getItem('token') },
      headers,
    },
  );
  return response.data;
};
